import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';

const GovernancePage: React.FC = () => {

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="h-16" />
      <Breadcrumb />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            운영세칙
          </h1>
        </div>

        {/* Operating Regulations */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">연구센터 운영세칙</h2>
            <p className="text-lg text-gray-600">
              서울여자대학교 인간-AI 협력 연구센터의 운영에 관한 규정입니다.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-sm">
            <div className="prose max-w-none">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">제 1 장 총 칙</h3>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 1 조(명칭)</h4>
                <p className="text-gray-700">본 연구센터는 서울여자대학교 인간-AI 협력 연구센터(Center for Human-AI Collaboration, CHAI)라 칭한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 2 조(위치)</h4>
                <p className="text-gray-700">본 연구센터는 서울여자대학교 미래산업융합연구소 산하에 둔다.</p>
              </div>

              <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 3 조(목적)</h4>
                <p className="text-gray-700">본 연구센터는 산⋅학⋅연⋅지 협력체계를 통하여 인간-AI 협력 모델의 개발 및 인력양성에 관한 제반 연구를 수행하고, 관련 교육 모델 및 교육과정의 개발과 확산을 목적으로 한다.</p>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6">제 2 장 사 업</h3>
              
              <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 4 조(사업내용)</h4>
                <p className="text-gray-700 mb-3">본 연구센터는 제 3 조의 목적을 달성하기 위하여 다음과 같은 사업을 수행한다.</p>
                <ol className="list-decimal list-inside space-y-2 text-gray-700">
                  <li>인간-AI 협력 모델 연구 및 개발 사업</li>
                  <li>학술활동 개최
                    <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                      <li>공개강좌</li>
                      <li>연구발표회</li>
                      <li>학술토론회</li>
                    </ul>
                  </li>
                  <li>국내·외 연구기관 및 단체 등과의 학술교류</li>
                  <li>학술용역사업 및 외부 수탁 연구의 수행</li>
                  <li>인력 양성 및 이에 필요한 교육과정 개발</li>
                </ol>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6">제 3 장 연 구 원</h3>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 5 조(연구원의 구분)</h4>
                <p className="text-gray-700 mb-3">본 연구센터는 다음과 같은 연구원을 둘 수 있다.</p>
                <ol className="list-decimal list-inside space-y-1 text-gray-700">
                  <li>상임 연구원</li>
                  <li>연구 보조원</li>
                  <li>객원 연구원</li>
                </ol>
              </div>

              <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 6 조(연구원의 자격)</h4>
                <div className="space-y-3 text-gray-700">
                  <div>
                    <p className="mb-2">① 상임 연구원은 연구센터의 사업을 전담하여 수행하는 인력으로, 본교의 인사 규정에 따라 임용한다.</p>
                    <ul className="list-disc list-inside ml-4 space-y-1">
                      <li>관련 분야에서 연구경력 또는 실무경력을 가진 자</li>
                      <li>본 연구센터에 소속하여 외부기관으로부터 지원받은 연구 과제를 수행하는 자</li>
                    </ul>
                  </div>
                  <p>② 연구 보조원은 본 연구센터의 사업을 보조하는 인력으로 학사 이상의 학위 소지자로서 운영위원회의 의결을 거쳐 연구센터장이 임명한다.</p>
                  <p>③ 객원 연구원은 탁월한 연구업적 또는 실무경험이 풍부한 산⋅학⋅연⋅지 분야 외부 전문인력으로 구성하며, 운영위원회의 의결을 거쳐 연구센터장이 임명한다.</p>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6">제 4 장 기구 (임원 및 운영위원회)</h3>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 7 조(임원)</h4>
                <p className="text-gray-700 mb-3">본 연구센터는 연구사업의 실무를 담당하기 위하여 다음과 같은 임원을 두며, 임기는 2년으로 한다.</p>
                <ol className="list-decimal list-inside space-y-1 text-gray-700">
                  <li>센터장 1명</li>
                  <li>상임 연구원 10명 내외</li>
                  <li>간사 1명</li>
                </ol>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 8 조(센터장)</h4>
                <p className="text-gray-700">센터장은 센터 소속 상임 연구원 중에서 총장이 임명하며, 센터를 대표하여 제반 연구센터 업무를 지휘 총괄한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 9 조(상임 연구원)</h4>
                <p className="text-gray-700">상임 연구원은 미래산업융합대학 소속 전임 교수 중에서 센터장이 임명하며, 연구 및 교육 업무를 수행한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 10 조(간사)</h4>
                <p className="text-gray-700">간사는 센터장이 위촉하고 연구센터 운영에 요구되는 제반 행정업무를 담당한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 11 조(운영위원회)</h4>
                <p className="text-gray-700">운영위원회는 연구센터 운영에 관한 중요사항을 심의⋅의결한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 12 조(운영위원회의 구성)</h4>
                <p className="text-gray-700">운영위원회는 센터장이 위촉하는 7명 내외의 상임 연구원으로 구성하며, 위원장은 센터장이 된다. 위원의 임기는 1년으로 한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 13 조(운영위원장)</h4>
                <p className="text-gray-700">운영위원장은 회무를 관장하며 위원회를 소집하고 그 의장이 된다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 14 조(운영위원회 직능)</h4>
                <p className="text-gray-700 mb-3">운영위원회는 다음 각 호의 사항을 심의 의결한다.</p>
                <ol className="list-decimal list-inside space-y-1 text-gray-700">
                  <li>연구센터의 사업계획과 예산에 관한 사항</li>
                  <li>연구센터 인사에 관한 사항</li>
                  <li>연구센터 제 규정의 개폐에 관한 사항</li>
                  <li>기타 센터 운영에 필요한 중요사항</li>
                </ol>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 15 조(의결)</h4>
                <p className="text-gray-700">운영위원회는 재적위원 과반수 출석으로 하고, 출석위원 과반수의 찬성으로 의결한다.</p>
              </div>

              <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 16 조(자문위원회)</h4>
                <p className="text-gray-700">본 연구센터는 연구사업의 수행 및 센터 사업의 기획⋅평가를 위하여 교내외 전문가로 구성된 약간의 자문위원을 둘 수 있다. 자문위원은 센터장의 추천으로 운영위원회에서 인준하며 임기는 1년으로 한다. 자문위원회는 센터장이 필요시 소집⋅운영한다.</p>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6">제 5 장 재 정</h3>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 17 조(회계)</h4>
                <p className="text-gray-700">본 센터의 회계연도는 서울여자대학교 회계연도에 따른다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 18 조(재원)</h4>
                <p className="text-gray-700">본 센터의 재정은 국내·외 각 기관의 지원금, 학술용역 사업의 수입금 및 기타수입으로 충당한다.</p>
              </div>

              <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 19 조(기관수익금)</h4>
                <p className="text-gray-700">본 센터의 이름으로 수행되는 모든 연구과제 및 연구용역 활동은 그 연구비 총액의 5%를 센터 수입금으로 적립한다.</p>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6">제 6 장 보 칙</h3>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 20 조(시행세칙의 개폐)</h4>
                <p className="text-gray-700">본 연구센터 규정의 개정은 센터장 또는 상임 연구원 3분의 1이상의 제의로 발의하여 운영위원회에서 재적위원 3분의 2이상의 찬성으로 의결한다.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">제 21 조(시행일)</h4>
                <p className="text-gray-700">본 규정은 2025년 8월 1일부터 시행한다.</p>
              </div>
            </div>
          </div>
        </section>


        {/* Call to Action */}
        <section className="text-center bg-teal-50/60 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            인간-AI 협력 연구센터와 함께하세요
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            서울여자대학교 인간-AI 협력 연구센터의 운영세칙에 따라 투명하고 체계적인 연구를 수행합니다.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/faculty" 
              className="inline-flex items-center px-6 py-3 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition-colors"
            >
              교수진 소개 보기
            </Link>
            <Link 
              to="/divisions" 
              className="inline-flex items-center px-6 py-3 bg-white text-teal-600 font-medium rounded-lg border border-teal-500 hover:bg-teal-50/60 transition-colors"
            >
              연구 분과 알아보기
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default GovernancePage;
